import PropTypes from 'prop-types'

import { pressable } from '@aytm/app/stats/components/lib/pressable'

// styles
import style from '@aytm/app/stats/page/question-views/components/controls/styles/Controls.module.scss'
import { NO_PRINT } from '@aytm/app/stats/page/question-views/components/lib/constants'

const Controls = ({ chartCollapsed, onToggle }) => (
  <div className={`${style.component} ${NO_PRINT}`}>
    <span className="p-field">Shop Metrics</span>
    <span
      className={`${style.toggle} p-right`}
      aria-expanded={!chartCollapsed}
      {...pressable(() => onToggle(!chartCollapsed))}
    >
      {chartCollapsed ? 'Expand' : 'Collapse'}
    </span>
  </div>
)

Controls.propTypes = {
  chartCollapsed: PropTypes.bool,
  onToggle: PropTypes.func
}

Controls.displayName = 'Controls'

export default Controls
